import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { 
  FaCar, 
  FaSearch, 
  FaShieldAlt, 
  FaStar, 
  FaCheckCircle,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebook,
  FaInstagram,
  FaWhatsapp
} from 'react-icons/fa';
import './LandingPage.css';

const logo = '/teucarro_logo.png';

const LandingPage = () => {
  return (
    <div className="landing-page">
      {/* Header/Navbar */}
      <nav className="navbar-custom">
        <Container>
          <div className="navbar-content">
            <img src={logo} alt="TeuCarro Logo" className="navbar-logo" />
            <div className="navbar-links">
              <a href="#inicio">Início</a>
              <a href="#sobre">Sobre</a>
              <a href="#servicos">Serviços</a>
              <a href="#contato">Contato</a>
            </div>
          </div>
        </Container>
      </nav>

      {/* Hero Section */}
      <section id="inicio" className="hero-section">
        <Container>
          <Row className="align-items-center min-vh-100">
            <Col lg={6} className="hero-content">
              <h1 className="hero-title">
                Encontre o <span className="text-highlight">carro dos seus sonhos</span>
              </h1>
              <p className="hero-subtitle">
                A melhor plataforma para encontrar, comparar e comprar o veículo perfeito para você.
                Com segurança, transparência e as melhores condições do mercado.
              </p>
              <div className="hero-buttons">
                <Button variant="primary" size="lg" className="me-3">
                  <FaSearch className="me-2" />
                  Buscar Carros
                </Button>
                <Button variant="outline-primary" size="lg">
                  Vender meu Carro
                </Button>
              </div>
            </Col>
            <Col lg={6} className="hero-image-col">
              <div className="hero-image-wrapper">
                <img src={logo} alt="TeuCarro" className="hero-logo" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Features Section */}
      <section id="servicos" className="features-section">
        <Container>
          <Row>
            <Col className="text-center mb-5">
              <h2 className="section-title">Por que escolher o TeuCarro?</h2>
              <p className="section-subtitle">
                Oferecemos as melhores soluções para sua busca automotiva
              </p>
            </Col>
          </Row>
          <Row className="g-4">
            <Col md={4}>
              <Card className="feature-card h-100">
                <Card.Body className="text-center">
                  <div className="feature-icon">
                    <FaSearch />
                  </div>
                  <Card.Title>Busca Inteligente</Card.Title>
                  <Card.Text>
                    Encontre exatamente o que procura com nossa busca avançada e filtros personalizados.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="feature-card h-100">
                <Card.Body className="text-center">
                  <div className="feature-icon">
                    <FaShieldAlt />
                  </div>
                  <Card.Title>Segurança Total</Card.Title>
                  <Card.Text>
                    Todas as transações são seguras e verificadas. Seus dados estão protegidos conosco.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="feature-card h-100">
                <Card.Body className="text-center">
                  <div className="feature-icon">
                    <FaStar />
                  </div>
                  <Card.Title>Melhor Avaliação</Card.Title>
                  <Card.Text>
                    Milhares de clientes satisfeitos nos avaliam com 5 estrelas. Confiança comprovada.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="feature-card h-100">
                <Card.Body className="text-center">
                  <div className="feature-icon">
                    <FaCheckCircle />
                  </div>
                  <Card.Title>Verificação Completa</Card.Title>
                  <Card.Text>
                    Todos os veículos passam por uma verificação completa antes de serem listados.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="feature-card h-100">
                <Card.Body className="text-center">
                  <div className="feature-icon">
                    <FaCar />
                  </div>
                  <Card.Title>Ampla Seleção</Card.Title>
                  <Card.Text>
                    Milhares de veículos disponíveis, desde modelos populares até os mais exclusivos.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="feature-card h-100">
                <Card.Body className="text-center">
                  <div className="feature-icon">
                    <FaPhoneAlt />
                  </div>
                  <Card.Title>Suporte Dedicado</Card.Title>
                  <Card.Text>
                    Nossa equipe está sempre pronta para ajudar você em cada etapa do processo.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* About Section */}
      <section id="sobre" className="about-section">
        <Container>
          <Row className="align-items-center">
            <Col lg={6}>
              <div className="about-image-wrapper">
                <img src={logo} alt="TeuCarro" className="about-logo" />
              </div>
            </Col>
            <Col lg={6}>
              <h2 className="section-title">Sobre o TeuCarro</h2>
              <p className="about-text">
                A plataforma TeuCarro é um engajamento que no futuro pode ser tornar um mecanismo de venda. 
                Estamos trabalhando e desenvolvendo a plataforma.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Contact Section */}
      <section id="contato" className="contact-section">
        <Container>
          <Row>
            <Col className="text-center mb-5">
              <h2 className="section-title">Entre em Contato</h2>
              <p className="section-subtitle">
                Estamos prontos para ajudar você a encontrar o carro perfeito
              </p>
            </Col>
          </Row>
          <Row className="g-4">
            <Col md={4}>
              <Card className="contact-card h-100">
                <Card.Body className="text-center">
                  <div className="contact-icon">
                    <FaPhoneAlt />
                  </div>
                  <Card.Title>Telefone</Card.Title>
                  <Card.Text>
                    <a href="tel:+5535999640116">35 99964 0116</a>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="contact-card h-100">
                <Card.Body className="text-center">
                  <div className="contact-icon">
                    <FaEnvelope />
                  </div>
                  <Card.Title>E-mail</Card.Title>
                  <Card.Text>
                    <a href="mailto:ssilveira1977@gmail.com">ssilveira1977@gmail.com</a>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="contact-card h-100">
                <Card.Body className="text-center">
                  <div className="contact-icon">
                    <FaMapMarkerAlt />
                  </div>
                  <Card.Title>Endereço</Card.Title>
                  <Card.Text>
                    São Paulo, SP<br />
                    Brasil
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Footer */}
      <footer className="footer-custom">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <img src={logo} alt="TeuCarro Logo" className="footer-logo" />
              <p className="footer-text">
                © 2024 TeuCarro. Todos os direitos reservados.
              </p>
            </Col>
            <Col md={6} className="text-md-end">
              <div className="social-links">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <FaFacebook />
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <FaInstagram />
                </a>
                <a href="https://wa.me/5511999999999" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                  <FaWhatsapp />
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </div>
  );
};

export default LandingPage;

